"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serialize = void 0;
const escape_html_1 = __importDefault(require("escape-html"));
const slate_1 = require("slate");
function serialize(node) {
    var _a;
    if (slate_1.Text.isText(node)) {
        let string = (0, escape_html_1.default)(node.text);
        if (node.bold) {
            string = `<strong>${string}</strong>`;
        }
        if (node.italic) {
            string = `<em>${string}</em>`;
        }
        if (node.underline) {
            string = `<u>${string}</u>`;
        }
        if (node.code) {
            string = `<code>${string}</code>`;
        }
        if (node.link) {
            let fileAttibutes = '';
            if (node.link.name) {
                fileAttibutes = `data-name=${node.link.name}`;
            }
            if (node.link.contentType) {
                fileAttibutes = `${fileAttibutes} data-content-type=${node.link.contentType} `;
            }
            if (node.link.size) {
                fileAttibutes = `${fileAttibutes} data-size=${node.link.size} `;
            }
            string = `<a href=${node.link.url} ${fileAttibutes} target=_blank rel=noreferrer>${string}</a>`;
        }
        return string;
    }
    let children;
    if (((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) !== undefined) {
        children = node.children;
    }
    else if ((node === null || node === void 0 ? void 0 : node.length) !== undefined) {
        children = node;
    }
    else {
        children = [];
    }
    const strigifiedChildren = children.map((n) => serialize(n)).join('');
    switch (node.type) {
        case 'bulleted-list':
            return `<ul>${strigifiedChildren}</ul>`;
        case 'numbered-list':
            return `<ol>${strigifiedChildren}</ol>`;
        case 'list-item':
            return `<li>${strigifiedChildren}</li>`;
        case 'bold':
            return `<strong>${strigifiedChildren}</strong>`;
        case 'italic':
            return `<em>${strigifiedChildren}</em>`;
        case 'underline':
            return `<u>${strigifiedChildren}</u>`;
        case 'code':
            return `<code>${strigifiedChildren}</code>`;
        case 'link':
            return `<a href=${node.link.url} target=_blank rel=noreferrer>${strigifiedChildren}</a>`;
        case 'paragraph':
            return `<p>${strigifiedChildren}</p>`;
        case 'block-quote':
            return `<blockquote>${strigifiedChildren}</blockquote>`;
        case 'heading-one':
            return `<h1>${strigifiedChildren}</h1>`;
        case 'heading-two':
            return `<h2>${strigifiedChildren}</h2>`;
        default:
            return strigifiedChildren;
    }
}
exports.serialize = serialize;
//# sourceMappingURL=serialize.js.map